module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px",
      "min-width": "600px"
    },
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "edit-form",
    attrs: {
      "label": "销售下单号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderCode))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "销售下单状态"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "代理商"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentCode) + " " + _vm._s(_vm.Form.AgentName) + " " + _vm._s(_vm.Form.AgentAddress) + " " + _vm._s(_vm.Form.AgentTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "销售下单时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "销售下单人"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SaleEmployeeName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.ProductList != ''),
      expression: "Form.ProductList!=''"
    }],
    staticClass: "edit-form w100",
    attrs: {
      "label": "商品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.ProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "商品数量"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": " "
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v("销售总价:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.Form.Total))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.GiftList != ''),
      expression: "Form.GiftList!=''"
    }],
    staticClass: "edit-form",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "label": "赠品"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "40%",
      "margin-left": "25px"
    },
    attrs: {
      "data": _vm.Form.GiftList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "订单数"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Form.IsShowPrice),
      expression: "Form.IsShowPrice"
    }],
    attrs: {
      "label": "凭证"
    }
  }, [_c('div', {
    staticClass: "show-img-ctn uclear"
  }, [_vm._l((_vm.Form.VoucherPic), function(item, index) {
    return [_c('div', {
      staticClass: "show-img-cell",
      on: {
        "click": function($event) {
          _vm.LookPicture(item.Url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": item.Name,
        "src": item.Url
      }
    })])]
  })], 2)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.PictureVisible),
      callback: function($$v) {
        _vm.PictureVisible = $$v
      },
      expression: "PictureVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.AgentConsignee))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "收货人及联系方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.Consignee) + "--" + _vm._s(_vm.Form.ConsigneeTel))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "寄送方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.SendModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "支付方式"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Form.PayModeName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "edit-form w100",
    attrs: {
      "label": "销售下单备注"
    }
  }, [(_vm.Form.OrderRemark != undefined && _vm.Form.OrderRemark != '') ? _c('span', [_vm._v(_vm._s(_vm.Form.OrderRemark))]) : _c('span', [_vm._v("--")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0df6cb7f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/AuditViewOrder.vue
// module id = 1381
// module chunks = 1